var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBannerGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.414 5.79263L19.0605 5.43913C18.475 4.85362 17.525 4.85362 16.9395 5.43913L11.707 10.6716L6.475 5.43913C5.889 4.85362 4.939 4.85362 4.3535 5.43913L4 5.79263L10.293 12.0856L4 18.3786L4.3535 18.7321C4.939 19.3176 5.889 19.3176 6.475 18.7321L11.707 13.4996L16.9395 18.7321C17.525 19.3176 18.475 19.3176 19.0605 18.7321L19.414 18.3786L13.121 12.0856L19.414 5.79263Z",
    fill: "#B3B6B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBannerGrey);
export default __webpack_public_path__ + "static/media/closeBanner_grey.f6d259b6ca67f865a0c132bb5d4fa1c8.svg";
export { ForwardRef as ReactComponent };